import PropTypes from 'prop-types';
import { SIZES } from '../base-select/constants';
import {
  OPTION_TYPE as BASE_SELECT_OPTION_TYPE,
  GROUP_OPTION_TYPE as BASE_SELECT_GROUP_OPTION_TYPE,
} from '../base-select/types';
import noop from '../../../utils/noop';

export const OPTION_TYPE = BASE_SELECT_OPTION_TYPE;
export const GROUP_OPTION_TYPE = BASE_SELECT_GROUP_OPTION_TYPE;

export const AUTOCOMPLETE_PROPS = {
  clearable: PropTypes.bool,
  defaultInputValue: PropTypes.string,
  inputValue: PropTypes.string,
  disabled: PropTypes.bool,
  blurInputOnSelect: PropTypes.bool,
  captureMenuScroll: PropTypes.bool,
  id: PropTypes.string,
  invalid: PropTypes.bool,
  asyncConfig: PropTypes.shape({
    loadOptions: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    cacheOptions: PropTypes.oneOfType([PropTypes.shape(), PropTypes.bool]),
    defaultOptions: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.shape(GROUP_OPTION_TYPE), PropTypes.shape(OPTION_TYPE)])
      ),
    ]),
  }),
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onCreateOption: PropTypes.func,
  filterOptionsFunction: PropTypes.func,
  onFocus: PropTypes.func,
  onInputChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(GROUP_OPTION_TYPE), PropTypes.shape(OPTION_TYPE)])
  ),
  placeholder: PropTypes.string,
  preventOverflow: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
  transparent: PropTypes.bool,
  iconComponent: PropTypes.element,
  prefixTextComponent: PropTypes.element,
  defaultMenuIsOpen: PropTypes.bool,
  autoFocus: PropTypes.bool,
  openMenuOnFocus: PropTypes.bool,
  menuIsOpen: PropTypes.bool,
  noResultsText: PropTypes.string,
  maxMenuHeight: PropTypes.number,
  menuWidth: PropTypes.string,
  shouldMarkSelectedOption: PropTypes.bool,
  withDropdownIndicator: PropTypes.bool,
};
